import { Flex } from '@atlaskit/primitives';
import SelectOptionTag from '@databases/tag/SelectOptionTag';
import { type DatabaseFieldType } from '@databases/types/database';
import React, { type FunctionComponent } from 'react';

import { type ViewComponentProps } from './types';

const SelectValueView: FunctionComponent<
  ViewComponentProps<DatabaseFieldType.SELECT>
> = ({ field, value, showDisabledValue }) => {
  return (
    <Flex testId="select-value-view" gap="space.100" wrap="wrap">
      {field.settings.selectOptions.flatMap((option) => {
        if (!value.some((val) => val === (option.id ?? option.label))) {
          return [];
        }

        return [
          <SelectOptionTag
            key={option.id ?? option.label}
            option={option}
            noMargin
            showDisabledValue={showDisabledValue}
          />,
        ];
      })}
    </Flex>
  );
};

export default SelectValueView;
